import Palette from './Palette';
import StructuralElement from '../../chem/StructuralElement';

const palette = new Palette('Jmol', 'JM');

palette.colors = [
  /* eslint-disable no-magic-numbers */
  0x0000FF, // blue
  0x0055FF, //
  0x00ABFF, //
  0x00FFFF, // cyan
  0x00FFAB, //
  0x00FF55, //
  0x00FF00, // green
  0x55FF00, //
  0xABFF00, //
  0xFFFF00, // yellow
  0xFFAB00, //
  0xFF5500, //
  0xFF0000, // red
  0xFF0055, //
  0xFF00AB, //
  0xFF00FF, // magenta
  0xAB00FF, //
  0x5500FF, //
  /* eslint-enable no-magic-numbers */
];

// DO NOT EDIT MANUALLY! Autogenerated from atom_types.csv by atom_types.py.
palette.elementColors = {
  /* eslint-disable no-magic-numbers */
  H: 0xFFFFFF,
  D: 0xFFFFC0,
  T: 0xFFFFA0,
  HE: 0xD9FFFF,
  LI: 0xCC80FF,
  BE: 0xC2FF00,
  B: 0xFFB5B5,
  C: 0x909090,
  N: 0x3050F8,
  O: 0xFF0D0D,
  F: 0x90E050,
  NE: 0xB3E3F5,
  NA: 0xAB5CF2,
  MG: 0x8AFF00,
  AL: 0xBFA6A6,
  SI: 0xF0C8A0,
  P: 0xFF8000,
  S: 0xFFFF30,
  CL: 0x1FF01F,
  AR: 0x80D1E3,
  K: 0x8F40D4,
  CA: 0x3DFF00,
  SC: 0xE6E6E6,
  TI: 0xBFC2C7,
  V: 0xA6A6AB,
  CR: 0x8A99C7,
  MN: 0x9C7AC7,
  FE: 0xE06633,
  CO: 0xF090A0,
  NI: 0x50D050,
  CU: 0xC88033,
  ZN: 0x7D80B0,
  GA: 0xC28F8F,
  GE: 0x668F8F,
  AS: 0xBD80E3,
  SE: 0xFFA100,
  BR: 0xA62929,
  KR: 0x5CB8D1,
  RB: 0x702EB0,
  SR: 0x00FF00,
  Y: 0x94FFFF,
  ZR: 0x94E0E0,
  NB: 0x73C2C9,
  MO: 0x54B5B5,
  TC: 0x3B9E9E,
  RU: 0x248F8F,
  RH: 0x0A7D8C,
  PD: 0x006985,
  AG: 0xC0C0C0,
  CD: 0xFFD98F,
  IN: 0xA67573,
  SN: 0x668080,
  SB: 0x9E63B5,
  TE: 0xD47A00,
  I: 0x940094,
  XE: 0x429EB0,
  CS: 0x57178F,
  BA: 0x00C900,
  LA: 0x70D4FF,
  CE: 0xFFFFC7,
  PR: 0xD9FFC7,
  ND: 0xC7FFC7,
  PM: 0xA3FFC7,
  SM: 0x8FFFC7,
  EU: 0x61FFC7,
  GD: 0x45FFC7,
  TB: 0x30FFC7,
  DY: 0x1FFFC7,
  HO: 0x00FF9C,
  ER: 0x00E675,
  TM: 0x00D452,
  YB: 0x00BF38,
  LU: 0x00AB24,
  HF: 0x4DC2FF,
  TA: 0x4DA6FF,
  W: 0x2194D6,
  RE: 0x267DAB,
  OS: 0x266696,
  IR: 0x175487,
  PT: 0xD0D0E0,
  AU: 0xFFD123,
  HG: 0xB8B8D0,
  TL: 0xA6544D,
  PB: 0x575961,
  BI: 0x9E4FB5,
  PO: 0xAB5C00,
  AT: 0x754F45,
  RN: 0x428296,
  FR: 0x420066,
  RA: 0x007D00,
  AC: 0x70ABFA,
  TH: 0x00BAFF,
  PA: 0x00A1FF,
  U: 0x008FFF,
  NP: 0x0080FF,
  PU: 0x006BFF,
  AM: 0x545CF2,
  CM: 0x785CE3,
  BK: 0x8A4FE3,
  CF: 0xA136D4,
  ES: 0xB31FD4,
  FM: 0xB31FBA,
  MD: 0xB30DA6,
  NO: 0xBD0D87,
  LR: 0xC70066,
  RF: 0xCC0059,
  DB: 0xD1004F,
  SG: 0xD90045,
  BH: 0xE00038,
  HS: 0xE6002E,
  MT: 0xEB0026,
  /* eslint-enable no-magic-numbers */
};

palette.defaultResidueColor = 0xBEA06E;

// DO NOT EDIT MANUALLY! Autogenerated from residue_types.csv by residue_types.py.
palette.residueColors = {
  /* eslint-disable no-magic-numbers */
  ALA: 0xC8C8C8,
  ARG: 0x145AFF,
  ASN: 0x00DCDC,
  ASP: 0xE60A0A,
  CYS: 0xE6E600,
  GLN: 0x00DCDC,
  GLU: 0xE60A0A,
  GLY: 0xEBEBEB,
  HIS: 0x8282D2,
  ILE: 0x0F820F,
  LEU: 0x0F820F,
  LYS: 0x145AFF,
  MET: 0xE6E600,
  PHE: 0x3232AA,
  PRO: 0xDC9682,
  SER: 0xFA9600,
  THR: 0xFA9600,
  TRP: 0xB45AB4,
  TYR: 0x3232AA,
  VAL: 0x0F820F,
  A: 0xA0A0FF,
  C: 0xFF8C4B,
  G: 0xFF7070,
  I: 0x80FFFF,
  T: 0xA0FFA0,
  U: 0xFF8080,
  DA: 0xA0A0FF,
  DC: 0xFF8C4B,
  DG: 0xFF7070,
  DI: 0x80FFFF,
  DT: 0xA0FFA0,
  DU: 0xFF8080,
  '+A': 0xA0A0FF,
  '+C': 0xFF8C4B,
  '+G': 0xFF7070,
  '+I': 0x80FFFF,
  '+T': 0xA0FFA0,
  '+U': 0xFF8080,
  /* eslint-enable no-magic-numbers */
};

palette.chainColors = [
  // ' '->0 'A'->1, 'B'->2
  0xFFffffff, // ' ' & '0' white
  //
  0xFFC0D0FF, // skyblue
  0xFFB0FFB0, // pastel green
  0xFFFFC0C8, // pink
  0xFFFFFF80, // pastel yellow
  0xFFFFC0FF, // pastel magenta
  0xFFB0F0F0, // pastel cyan
  0xFFFFD070, // pastel gold
  0xFFF08080, // lightcoral

  0xFFF5DEB3, // wheat
  0xFF00BFFF, // deepskyblue
  0xFFCD5C5C, // indianred
  0xFF66CDAA, // mediumaquamarine
  0xFF9ACD32, // yellowgreen
  0xFFEE82EE, // violet
  0xFF00CED1, // darkturquoise
  0xFF00FF7F, // springgreen
  0xFF3CB371, // mediumseagreen

  0xFF00008B, // darkblue
  0xFFBDB76B, // darkkhaki
  0xFF006400, // darkgreen
  0xFF800000, // maroon
  0xFF808000, // olive
  0xFF800080, // purple
  0xFF008080, // teal
  0xFFB8860B, // darkgoldenrod
  0xFFB22222, // firebrick
];

const StructuralElementType = StructuralElement.Type;

palette.secondaryColors = {
  [StructuralElementType.HELIX_ALPHA]: 0xFF0080,
  [StructuralElementType.HELIX_PI]: 0x600080,
  [StructuralElementType.HELIX_310]: 0xA00080,
  [StructuralElementType.STRAND]: 0xFFC800,
  [StructuralElementType.TURN]: 0x6080FF,
  dna: 0xAE00FE,
  rna: 0xFD0162,
};

export default palette;
